export function CornerBrackets({ color }: { color?: string }) {
  const style = color ? { borderColor: color } : undefined;
  return (
    <>
      <span
        className="pointer-events-none absolute top-3.5 left-3.5 h-6 w-6 border-l border-t border-gold-400/60"
        style={style}
      />
      <span
        className="pointer-events-none absolute top-3.5 right-3.5 h-6 w-6 border-r border-t border-gold-400/60"
        style={style}
      />
      <span
        className="pointer-events-none absolute bottom-3.5 left-3.5 h-6 w-6 border-l border-b border-gold-400/60"
        style={style}
      />
      <span
        className="pointer-events-none absolute bottom-3.5 right-3.5 h-6 w-6 border-r border-b border-gold-400/60"
        style={style}
      />
    </>
  );
}
